import { render, staticRenderFns } from "./dashboard.vue.html?vue&type=template&id=1d4dde8c&scoped=true&"
import script from "./dashboard.ts?vue&type=script&lang=ts&"
export * from "./dashboard.ts?vue&type=script&lang=ts&"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=1d4dde8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4dde8c",
  null
  
)

export default component.exports